import React from 'react'
import { Icon } from './ToDoList.elements'

type Props = {
  className?: string
}

export const ToDoListIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 80 80"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M61.491 44.858V16.475a1.9 1.9 0 00-1.9-1.9H17.8a1.9 1.9 0 00-1.9 1.9v51.29c0 1.049.85 1.9 1.9 1.9h28.215" stroke="#1A1C1F" strokeWidth="2"/>
    <path d="M32.997 13.607h1v-1a4.699 4.699 0 119.397 0v1h2.9a4.699 4.699 0 014.699 4.698v1.9a.9.9 0 01-.9.9H27.298a.9.9 0 01-.9-.9v-1.9a4.699 4.699 0 014.7-4.698h1.899z" fill="#fff" stroke="#1A1C1F" strokeWidth="2"/>
    <path d="M33 31h20" stroke="#1A1C1F" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M24.5 30.555l1.956 1.955 3.631-3.632" stroke="#1A1C1F" strokeWidth="2"/>
    <path d="M33 41.621h20" stroke="#1A1C1F" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M24.5 41.176l1.956 1.956 3.631-3.632" stroke="#1A1C1F" strokeWidth="2"/>
    <path d="M33 52h13" stroke="#1A1C1F" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M24.5 51.798l1.956 1.955 3.631-3.631" stroke="#1A1C1F" strokeWidth="2"/>
    <path d="M59.591 72.458c6.172 0 11.174-5.003 11.174-11.174 0-6.172-5.002-11.175-11.174-11.175-6.171 0-11.174 5.003-11.174 11.175 0 6.17 5.003 11.174 11.174 11.174z" stroke="#4CA9ED" strokeWidth="2"/>
    <path d="M54.935 61.085l3.448 3.448 6.974-6.974" stroke="#4CA9ED" strokeWidth="2"/>
  </Icon>
)
